import type { DataExplorerPageProps } from './types';
import {
  DataExplorerAppearanceProvider,
  useDataExplorerAppearance,
} from './appearanceContext';
import { resolveDataExplorerAppearance } from './theme';
import { cn } from './utils';

export function DataExplorerPage({
  sidebar,
  tree,
  toolbar,
  controls,
  notices,
  content,
  view,
  detail,
  appearance,
  className,
  classNames,
}: DataExplorerPageProps) {
  const resolvedAppearance = useDataExplorerAppearance(appearance);
  const theme = resolvedAppearance
    ? resolveDataExplorerAppearance(resolvedAppearance)
    : undefined;
  const sidebarNode = tree ?? sidebar;
  const toolbarNode = controls ?? toolbar;
  const contentNode = view ?? content;

  return (
    <DataExplorerAppearanceProvider appearance={resolvedAppearance}>
      <div
        className={cn(
          'flex h-full min-h-0 overflow-hidden',
          theme?.slots.surfaceRoot,
          classNames?.root,
          className,
        )}
        style={theme?.styles.surfaceRoot}
      >
      {sidebarNode ? (
        <div
          className={cn(
            'min-h-0 shrink-0 overflow-hidden',
            classNames?.sidebar,
            classNames?.tree,
          )}
        >
          {sidebarNode}
        </div>
      ) : null}

      <div
        className={cn(
          'relative flex min-h-0 flex-1 flex-col overflow-hidden',
          classNames?.main,
        )}
      >
        {toolbarNode ? (
          <div
            className={cn('shrink-0', classNames?.toolbar, classNames?.controls)}
          >
            {toolbarNode}
          </div>
        ) : null}

        {notices ? (
          <div className={cn('shrink-0', classNames?.notices)}>{notices}</div>
        ) : null}

        <div
          className={cn(
            'flex min-h-0 flex-1 flex-col overflow-hidden',
            classNames?.content,
            classNames?.view,
          )}
        >
          {contentNode}
        </div>

        {detail ? <div className={cn(classNames?.detail)}>{detail}</div> : null}
      </div>
      </div>
    </DataExplorerAppearanceProvider>
  );
}
